import type {ActionResponse} from 'src/typings';
import type {ActionRequestMethod} from '../constants';
import type FinishedResponseInteractionService from './finished-response-interaction.service';
import type ActionRequestDataService from '../data-services/action-request-data.service';
import {ngAsync} from '../utils/ng-@decorators';
import {isInterruptedActionResponse} from 'src/modals/modal-utils';
import {actionRequestMethods} from '../constants';

export default class ActionRequestService {
    public static serviceName = 'actionRequestService';

    /*@ngInject*/
    constructor(private actionRequestDataService: ActionRequestDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async action(requestPath: string,
                        requestMethod: ActionRequestMethod = actionRequestMethods.GET,
                        requestBody?: any,
                        successCallback?: ($actionResponse: ActionResponse) => void): Promise<void> {
        try {
            const actionResponse: ActionResponse = await this.actionRequestDataService.request(requestPath, requestMethod, requestBody);

            if (successCallback) {
                successCallback(actionResponse);
                return;
            }
            return await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);

        } catch (error) {
            if (!isInterruptedActionResponse(error)) {
                this.finishedResponseInteractionService.showFailedResponseInToast(error);
            }
            throw error;
        }
    }

}
